<div class="contract-notices-form-container">
	<span #clipsFormComponent></span>
	<div class="d-flex justify-content-end mx-3">
		<button mat-flat-button color="primary" class="d-flex justify-content-center ms-auto align-items-center"
			matTooltip="{{ 'CLIPS.SCREENSHOT_QUEUE' | translate }}" matTooltipPosition="below"
			(click)="openScreenshotQueue()">
			<mat-icon class="m-0" fontSet="material-icons-outlined">web_stories</mat-icon>
		</button>
		<button mat-flat-button color="primary" class="d-flex justify-content-center ms-1 align-items-center"
			matTooltip="{{ 'CONTRACT_NOTICES.MISSING_NOTICES' | translate }}" matTooltipPosition="below"
			(click)="openDeveloperListMissing()">
			<mat-icon class="m-0">fact_check</mat-icon>
		</button>
		@if(dataAdministrationType === 'CONTRACT_NOTICES') {
		<button mat-flat-button color="primary" class="d-flex justify-content-center ms-1 align-items-center"
			matTooltip="{{ 'CONTRACT_NOTICES.TRANSLATE' | translate }}" matTooltipPosition="below"
			[disabled]="apiLoading.translateContractNotices"
			(click)="showTranslateContractNoticesConfirmation()">
			@if(apiLoading.translateContractNotices) {
			<mat-spinner diameter="20"></mat-spinner>
			} @else {
			<mat-icon class="m-0">translate</mat-icon>
			}
		</button>
		}
		<button mat-flat-button color="primary" class="d-flex justify-content-center ms-1 align-items-center"
			matTooltip="{{ 'CONTRACT_NOTICES.AUTO_TAG' | translate }}" matTooltipPosition="below"
			(click)="openAutoTagDialog()">
			<mat-icon class="m-0">style</mat-icon>
		</button>
		<button mat-flat-button color="primary" class="d-flex justify-content-center ms-1 align-items-center"
			matTooltip="Developer Mode (instant process)" matTooltipPosition="below"
			[disabled]="apiLoading.contractNotice"
			(click)="instantProcessNotices()">
			@if(apiLoading.contractNotice) {
			<mat-spinner diameter="20"></mat-spinner>
			} @else {
			<mat-icon class="m-0">history_2></mat-icon>
			}
		</button>
		<button mat-flat-button color="primary" class="d-flex justify-content-center ms-1 align-items-center"
			matTooltip="Developer Mode (manual insert)" matTooltipPosition="below"
			(click)="manuallySaveEnabavki()">
			<mat-icon class="m-0">data_object</mat-icon>
		</button>
	</div>

	<form [formGroup]="contractNoticeFormGroup" #formContractNoticeDirective="ngForm" (submit)="submitContractNoticeForm(formContractNoticeDirective, $event)">
		<div class="row mx-1 mt-2">
			<div class="col">
				<div class="d-flex gap-1 pb-2">
					<mat-form-field [ngClass]="dataAdministrationType === 'CONTRACT_NOTICES' ? 'w-50' : 'w-100'">
						<mat-label>{{ 'CONTRACT_NOTICES.PUBLISHED_DATE' | translate }}</mat-label>
						<input tabindex="-1" matInput id="published-date" [matDatepicker]="publishedDatePicker" formControlName="publishedDate" />
						<mat-datepicker-toggle tabindex="-1" matIconSuffix [for]="publishedDatePicker"></mat-datepicker-toggle>
						<mat-datepicker #publishedDatePicker></mat-datepicker>
					</mat-form-field>

					@if(dataAdministrationType === 'CONTRACT_NOTICES') {
					<mat-form-field class="w-50">
						<mat-label>{{ 'CONTRACT_NOTICES.DELIVERY_DATE' | translate }}</mat-label>
						<input tabindex="-1" matInput id="delivery-date" [matDatepicker]="deliveryDatePicker" formControlName="deliveryDate" />
						<mat-datepicker-toggle tabindex="-1" matIconSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
						<mat-datepicker #deliveryDatePicker></mat-datepicker>
					</mat-form-field>
					}
				</div>

				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.TYPE' | translate }}</mat-label>
					<select id="type" style="display: none"></select>
					<!-- workaround for material-chrome bug -->
					<mat-select tabIndex="1" id="type" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="type" cdkFocusInitial>
						@for (type of types; track $index) {
						<mat-option [value]="type">{{ 'CONTRACT_NOTICES.' + type | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<mat-form-field class="field-with-insert-button w-100 pb-2" [ngClass]="{ 'disable-block': contractNoticeFormGroup.controls['mediumId'].disabled }">
					<mat-label>{{ 'CONTRACT_NOTICES.MEDIUM' | translate }}</mat-label>
					<mat-chip-grid #mediumGrid aria-label="Mediums selection">
						@for (medium of selectedMediums; track $index) {
						<mat-chip-row (removed)="itemAction('REMOVE', 'MEDIUM', medium)">
							{{ utils.getParameterByLanguageScript(medium, 'name') }}
							<button matChipRemove [attr.aria-label]="'remove ' + medium.id">
								<mat-icon>cancel</mat-icon>
							</button>
						</mat-chip-row>
						}
					</mat-chip-grid>
					<input
						[placeholder]="'BUTTON.SEARCH' | translate"
						#mediumInput
						formControlName="mediumId"
						[matChipInputFor]="mediumGrid"
						[matAutocomplete]="autoMediums"
						[matChipInputSeparatorKeyCodes]="utils.CHIPS_SEPERATOR_KEYS"
						(matChipInputTokenEnd)="itemAction('ADD', 'MEDIUM', $event)" />
					<mat-autocomplete #autoMediums="matAutocomplete" [displayWith]="displayFnMedium.bind(this)" (optionSelected)="itemAction('SELECT', 'MEDIUM', $event)">
						@for (medium of filteredMediums; track $index) {
						<mat-option [value]="medium">{{ utils.getParameterByLanguageScript(medium, 'name') }}</mat-option>
						}
					</mat-autocomplete>
					<button
						matSuffix
						mat-button
						type="button"
						color="primary"
						aria-label="Add medium"
						matTooltip="{{ 'BUTTON.CREATE' | translate }} {{ 'MEDIUM.TITLE' | translate }}"
						matTooltipPosition="below"
						(click)="itemAction('CREATE', 'MEDIUM', contractNoticeFormGroup.controls['mediumId'].value)">
						<mat-icon class="m-0">add</mat-icon>
					</button>
				</mat-form-field>
				@if(dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS') {
				<mat-form-field class="field-with-insert-button w-100 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.CONTRACTOR' | translate }}</mat-label>
					<mat-chip-grid #contractorGrid aria-label="Contractor select">
						@for (contractor of selectedContractors; track $index) {
						<mat-chip-row (removed)="itemAction('REMOVE', 'BUSINESS_ENTITY', contractor)">
							{{ utils.getParameterByLanguageScript(contractor, 'name', true) }}
							<button matChipRemove [attr.aria-label]="'remove' + contractor.id">
								<mat-icon>cancel</mat-icon>
							</button>
						</mat-chip-row>
						}
					</mat-chip-grid>
					<input type="text" matInput #contractorInput formControlName="contractorIds" [matAutocomplete]="contractorAutocomplete" [matChipInputFor]="contractorGrid" />
					<mat-autocomplete
						#contractorAutocomplete="matAutocomplete"
						(optionSelected)="itemAction('SELECT', 'BUSINESS_ENTITY', $event)"
						[displayWith]="displayFnBusinessEntity.bind(this)">
						@for (contractor of filteredBusinessEntities; track $index) {
						<mat-option [value]="contractor">{{ utils.getParameterByLanguageScript(contractor, 'name', true) }}</mat-option>
						}
					</mat-autocomplete>
					<button
						matSuffix
						mat-button
						type="button"
						color="primary"
						aria-label="Add business entity"
						matTooltip="{{ 'BUTTON.CREATE' | translate }} {{ 'BUSINESS_ENTITY.TITLE' | translate }}"
						matTooltipPosition="below"
						(click)="itemAction('CREATE', 'BUSINESS_ENTITY', contractNoticeFormGroup.controls['contractorIds'].value)">
						<mat-icon class="m-0">add</mat-icon>
					</button>
					<!-- @if(selectedContractors.length === 0 && selectedContractors.length === 0) {
					<div class="font hint">*{{ 'NOTIFICATIONS.REQUIRED_VALUE' | translate }}</div>
					} -->
				</mat-form-field>
				}

				<mat-form-field class="field-with-insert-button w-100 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.CONTRACT_AUTHORITY' | translate }}</mat-label>
					<input type="text" matInput formControlName="contractAuthorityId" [matAutocomplete]="contractAuthorityAutocomplete" />
					<mat-autocomplete #contractAuthorityAutocomplete="matAutocomplete" [displayWith]="displayFnBusinessEntity.bind(this)">
						@for (businessEntity of filteredBusinessEntities; track $index) {
						<mat-option [value]="businessEntity">{{ utils.getParameterByLanguageScript(businessEntity, 'name', true) }}</mat-option>
						}
					</mat-autocomplete>
					<button
						matSuffix
						mat-button
						type="button"
						color="primary"
						aria-label="Add business entity"
						matTooltip="{{ 'BUTTON.CREATE' | translate }} {{ 'BUSINESS_ENTITY.TITLE' | translate }}"
						matTooltipPosition="below"
						(click)="itemAction('CREATE', 'BUSINESS_ENTITY', contractNoticeFormGroup.controls['contractAuthorityId'].value)">
						<mat-icon class="m-0">add</mat-icon>
					</button>
				</mat-form-field>

				<mat-form-field class="w-100 pb-2">
					<mat-label
						>{{ 'CONTRACT_NOTICES.COUNTRY' | translate }}
						<!-- workaround for material-chrome bug -->
						<select id="country" style="display: none" autocomplete="country"></select>
					</mat-label>
					<mat-select id="country" formControlName="country">
						@for (country of countries; track $index) {
						<mat-option [value]="country">{{ 'COUNTRIES.' + country | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>

				@if(dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS' || (dataAdministrationType === 'CONTRACT_NOTICES' && (contractNoticeFormGroup.controls['type'].value === 'MODIFICATION' || contractNoticeFormGroup.controls['type'].value === 'CANCELLATION'))) {
				<mat-form-field class="field-with-insert-button w-100 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.CONTRACT_NOTICE' | translate }}</mat-label>
					<input type="text" matInput #contractNoticeInput formControlName="contractNoticeId" [matAutocomplete]="contractNoticeAutocomplete" />
					<mat-autocomplete 
						#contractNoticeAutocomplete="matAutocomplete" 
						(optionSelected)="itemAction('SELECT', 'CONTRACT_NOTICE', $event)"
						[displayWith]="displayFnContractNotice.bind(this)">
						@for (contractNotice of filteredContractNotices; track contractNotice.id) {
							<mat-option [value]="contractNotice" class="option-with-divider">
								<div class="contract-notice-option">
									<div class="contract-notice-subject-number">
										{{ utils.getParameterByLanguageScript(contractNotice, 'contractSubject', true) }} ({{ contractNotice.number }}) - {{ utils.formatDate(contractNotice.publishedDate) }}
									</div>
									<div class="contract-notice-authority">
										{{ utils.getParameterByLanguageScript(contractNotice.contractAuthority, 'name', true) }}
									</div>
								</div>
							</mat-option>
						}
					</mat-autocomplete>
				</mat-form-field>
				}

				<mat-tab-group [(selectedIndex)]="selectedTabIndex" headerPosition="above" mat-stretch-tabs="false">
					@for (langCode of avaliableLanguagesCodes; track $index) {
					<mat-tab label="">
						<ng-template mat-tab-label>
							<span>{{ 'NAVBAR.LANGUAGES.' + langCode | uppercase | translate }}</span>
						</ng-template>

						<mat-form-field class="w-100 py-2">
							<mat-label>{{ 'CONTRACT_NOTICES.CONTRACT_SUBJECT' | translate }}</mat-label>
							<input type="text" matInput [formControlName]="'contractSubject' + (langCode | titlecase)" />
						</mat-form-field>
					</mat-tab>
					}
				</mat-tab-group>

				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.CONTRACT_NOTICE_NUMBER' | translate }}</mat-label>
					<input type="text" matInput formControlName="number" />
				</mat-form-field>

				<mat-checkbox class="w-100 mb-2" color="primary" formControlName="divisiblePurchase">{{ 'CONTRACT_NOTICES.DIVISABLE_PURCHASE' | translate }}</mat-checkbox>

				@if (dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS' && contractNoticeFormGroup.controls['type'].value === 'CONTRACT_AWARD') {
				<div class="d-flex gap-2">
					<div class="d-flex flex-column flex-grow-1">
						<mat-form-field class="w-100 pb-2">
							<mat-label>{{ 'CONTRACT_NOTICES.ESTIMATED_PURCHASE_VALUE' | translate }}</mat-label>
							<input type="text" matInput formControlName="estimatedPurchaseValue" />
							<span matTextSuffix>{{ contractNoticeFormGroup.controls['currency'].value }}</span>
						</mat-form-field>

						<mat-form-field class="w-100 pb-2">
							<mat-label>{{ 'CONTRACT_NOTICES.AGREEMENT_VALUE' | translate }}</mat-label>
							<input type="text" matInput formControlName="agreementValue" />
							<span matTextSuffix>{{ contractNoticeFormGroup.controls['currency'].value }}</span>
						</mat-form-field>
					</div>

					<div class="d-flex align-items-center">
						<mat-form-field class="w-100">
							<mat-label>{{ 'CONTRACT_NOTICES.CURRENCY' | translate }}</mat-label>
							<mat-select formControlName="currency">
								<mat-option [value]="'MKD'">{{ 'CONTRACT_NOTICES.CURRENCY_TYPES.MKD' | translate }}</mat-option>
								<mat-option [value]="'EUR'">{{ 'CONTRACT_NOTICES.CURRENCY_TYPES.EUR' | translate }}</mat-option>
								<mat-option [value]="'USD'">{{ 'CONTRACT_NOTICES.CURRENCY_TYPES.USD' | translate }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
				} @else {
				<div class="d-flex gap-1">
					<mat-form-field class="w-75 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.ESTIMATED_PURCHASE_VALUE' | translate }}</mat-label>
					<input type="text" matInput formControlName="estimatedPurchaseValue" />
					<span matTextSuffix>{{ contractNoticeFormGroup.controls['currency'].value }}</span>
					</mat-form-field>

					<mat-form-field class="w-25 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.CURRENCY' | translate }}</mat-label>
					<mat-select formControlName="currency">
						<mat-option [value]="'MKD'">{{ 'CONTRACT_NOTICES.CURRENCY_TYPES.MKD' | translate }}</mat-option>
						<mat-option [value]="'EUR'">{{ 'CONTRACT_NOTICES.CURRENCY_TYPES.EUR' | translate }}</mat-option>
						<mat-option [value]="'USD'">{{ 'CONTRACT_NOTICES.CURRENCY_TYPES.USD' | translate }}</mat-option>
					</mat-select>
					</mat-form-field>
				</div>
				}

				@if (mode === 'EDIT') { @if(dataAdministrationType === 'CONTRACT_NOTICES') {
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.CONTRACT_TYPE' | translate }}</mat-label>
					<!-- <select id="contractType" style="display: none"></select>
            <mat-select tabIndex="1" id="contractType" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="procurementType">
              @for (type of contractTypes; track $index) {
              <mat-option [value]="type">{{ 'CONTRACT_NOTICES.CONTRACT_TYPES.' + type | translate }}</mat-option>
              }
            </mat-select> -->
					<input type="text" matInput formControlName="procurementType" />
				</mat-form-field>

				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.PROCEDURE_TYPE' | translate }}</mat-label>
					<!-- <select id="procedureType" style="display: none"></select>
					<mat-select tabIndex="1" id="procedureType" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="procedureType">
						@for (type of procedureTypes; track $index) {
						<mat-option [value]="type">{{ 'CONTRACT_NOTICES.PROCEDURE_TYPES.' + type | translate }}</mat-option>
						}
					</mat-select> -->
					<input type="text" matInput formControlName="procedureType" />
				</mat-form-field>
				} }

				<mat-form-field class="w-100 pt-2 field-with-insert-button">
					<mat-label>{{ 'CONTRACT_NOTICES.URL' | translate }}</mat-label>
					<input type="text" matInput formControlName="url" />
					<button
						type="button"
						matSuffix
						mat-flat-button
						color="accent"
						aria-label="Open in new tab"
						(click)="utils.openLinkInNewTab(contractNoticeFormGroup.controls['url'].value)"
						[disabled]="!contractNoticeFormGroup.controls['url'].value">
						<mat-icon class="m-0">open_in_new</mat-icon>
					</button>
				</mat-form-field>

				<mat-form-field class="field-with-insert-button w-100 pt-2">
					<mat-label>{{ 'CONTRACT_NOTICES.PDF_FILE' | translate }} / {{ 'CONTRACT_NOTICES.IMAGE' | translate }}</mat-label>
					<input type="text" matInput formControlName="fileUrl" readonly />
					<button
						type="button"
						matSuffix
						mat-flat-button
						color="primary"
						aria-label="Upload image"
						matTooltip="{{ 'BUTTON.UPLOAD' | translate }}"
						matTooltipPosition="below"
						(click)="fileInput.click()">
						<mat-icon class="m-0">upload</mat-icon>
					</button>
					<input hidden id="file" type="file" #fileInput [accept]="getAcceptedFileFormats()" (change)="selectFilesForUpload($event)" />
				</mat-form-field>
			</div>
			<div class="col ps-0">
				<mat-form-field class="w-100 h-100">
					<mat-label>{{ 'CONTRACT_NOTICES.DESCRIPTION' | translate }}</mat-label>
					<textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="8" formControlName="description"></textarea>
				</mat-form-field>
			</div>
		</div>

		<div class="d-flex mt-2 mx-3">
			<button
				type="button"
				mat-raised-button
				color="primary"
				class="me-1"
				aria-label="Reset form button"
				matTooltip="{{ 'CLIPS.RESET_FORM' | translate }}"
				matTooltipPosition="below"
				[disabled]="apiLoading.contractNotice"
				(click)="resetForm(formContractNoticeDirective)">
				<mat-icon class="m-0">restart_alt</mat-icon>
			</button>

			<button
				type="submit"
				mat-raised-button
				color="primary"
				class="w-100"
				aria-label="Create contract notice"
				[disabled]="!checkFormValidity() || !contractNoticeFormGroup.valid || apiLoading.contractNotice">
				@if(apiLoading.contractNotice) {
				<mat-spinner diameter="20"></mat-spinner>
				} @else {
				<span
					>{{ 'BUTTON.' + mode | translate }}
					@if(dataAdministrationType === 'CONTRACT_NOTICES') {
					{{ 'CONTRACT_NOTICES.CONTRACT_NOTICE' | translate }}
					} @else if(dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS') {
					{{ 'CONTRACT_ANNOUNCEMENTS.CONTRACT_ANNOUNCEMENT' | translate }}
					}
				</span>
				}
			</button>
		</div>
	</form>
</div>
